module.exports = __webpack_public_path__ + "img/medici.f16cee0b.png";